module.exports = __webpack_public_path__ + "img/demo-tourament-image.9a071620.png";